import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ResearchLab = () => {
  return (
    <>
    <Navbar />
    <div style={{ backgroundColor: "#f6fbfa" }}>

{/* HERO SECTION */}
<div
  style={{
    background: "linear-gradient(135deg, #3E826D, #0d6efd)",
    color: "white",
    padding: "100px 0",
  }}
>
  <Container className="text-center">
    <h1 className="fw-bold mb-4">
      Research Lab: Bridging Theory & Execution
    </h1>
    <p className="lead" style={{ maxWidth: "800px", margin: "0 auto" }}>
      Where 20 years of E&S expertise meets the frontier of AI. 
      We build the tools we wish we had as practitioners — solving 
      <strong> Data Overload </strong> and ensuring 
      <strong> Active Trust </strong> through verified intelligence.
    </p>
  </Container>
</div>

<Container className="py-5">

  {/* Innovation Section */}
  <Row className="text-center mb-5">
    <Col>
      <h2 className="fw-bold text-success mb-3">
        Innovation as a Service
      </h2>
      <p className="text-muted">
        Developed and tested concepts refined for real-world E&S workflows.
      </p>
    </Col>
  </Row>

  {/* reviewESRA Section */}
  <div className="mb-5 p-5 rounded-4 shadow-sm"
    style={{ backgroundColor: "#e9f7ef" }}
  >
    <Row className="mb-4">
      <Col>
        <h3 className="fw-bold text-success">
          reviewESRA: The Due Diligence Powerhouse
        </h3>
        <p className="text-muted">
          An instant benchmarking and ESDD engine accelerating review workflows for practitioners and lenders.
        </p>
      </Col>
    </Row>

    <Row className="g-4">
      {[
        "Upload full project knowledge bases and select key data points.",
        "Generate 3–5 page regulatory gap analysis reports (IFC, EBRD, local standards).",
        "Automated ESAP compliance tables with Status & Justification columns.",
        "30–50+ page full ESDD reports aligned with EBRD & IFC templates.",
        "Modular add-on for privatESRA users requiring enhanced privacy.",
      ].map((text, index) => (
        <Col md={6} key={index}>
          <Card
            className="border-0 shadow-sm rounded-4 h-100"
            style={{ transition: "0.3s" }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-6px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0px)")
            }
          >
            <Card.Body>
              <Card.Text className="text-muted fw-semibold">
                {text}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </div>

  {/* SmartESIA Section */}
  <div className="mb-5 p-5 rounded-4 shadow-sm"
    style={{ backgroundColor: "#eef4ff" }}
  >
    <Row className="mb-4">
      <Col>
        <h3 className="fw-bold text-primary">
          SmartESIA: The “80% Ready” Workflow
        </h3>
        <p className="text-muted">
          Transition from manual data entry to high-level strategic synthesis.
        </p>
      </Col>
    </Row>

    <Row className="g-4">
      {[
        "Agent-led baseline, legal framework & alternative analysis generation.",
        "Predictive impact assessments with mitigation suggestions.",
        "Guided primary data collection strategy (indicators, seasons, duration).",
        "Country-specific legal alignment — leaving final 20% to human expertise.",
      ].map((text, index) => (
        <Col md={6} key={index}>
          <Card
            className="border-0 shadow-sm rounded-4 h-100"
            style={{ transition: "0.3s" }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-6px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0px)")
            }
          >
            <Card.Body>
              <Card.Text className="text-muted fw-semibold">
                {text}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </div>

  {/* Research Commitment */}
  <Row className="text-center mb-5">
    <Col>
      <h2 className="fw-bold text-success mb-3">
        Our Research Commitment
      </h2>
      <p className="text-muted" style={{ maxWidth: "800px", margin: "0 auto" }}>
        We continuously experiment with advanced AI models to transform lab 
        concepts into consumer-ready tools. Our focus is ethical AI — 
        empowering E&S professionals with zero hallucinations and 
        insights grounded in verified data.
      </p>
    </Col>
  </Row>

  {/* CTA Buttons */}
  <Row className="text-center mb-5">
    <Col>
      <Button
        variant="success"
        size="lg"
        href="mailto:info@essolutions.ai"
        className="px-5 py-3 rounded-pill me-3 shadow"
      >
        Talk to an Expert
      </Button>

      <Button
        variant="outline-success"
        size="lg"
        href="mailto:info@essolutions.ai"
        className="px-5 py-3 rounded-pill"
      >
        Request Lab Access
      </Button>
    </Col>
  </Row>

</Container>
</div>
<Footer />
    </>
  );
};

export default ResearchLab;